import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {compose} from 'redux';
import {ReviewAttachments, Uploader} from 'go/components/common/attachments';
import FileTransferUtils, {
  withAttachmentApi,
} from 'go/components/common/attachments/uploader/utils';
import {API_ATTACHMENT_GET_SUCCESS} from 'common/types';
import ApiActions from 'go/actions/api';
import CollaborationActions from 'go/actions/api/collaboration';
import {Header, Segment, Loader} from 'semantic-ui-react';
import {
  isDisplayError,
  errorMessages,
  getFirstInvalidErrorMessage,
  isFemaUser,
} from 'common/utils';
import {rulesMap} from 'go/components/rules/rules';
import DynamicComponent from 'app-ui-componentlibrary/dist/go/components/dynamic/DeprecatedDynamicComponent';
import {produceAppliedDiff} from 'framework/collaboration/diff.utils';

const DEFAULT_VISIBILITY = 'internal';

export class _DynamicReviewAttachments extends DynamicComponent {
  constructor(props) {
    super(props);
    this.state = {
      attachments: [],
      attachmentIds: [],
      loading: true,
    };
    if (this.props.entityId !== undefined && !this.props.currentlyCollaborating) {
      this.retrieveAttachments();
    }

    this.updateRedux = this.updateRedux.bind(this);
  }

  componentDidMount() {
    if (this.props.currentlyCollaborating) {
      const {collaborationStorePath, collaborationRoomName} = this.props;
      this.props.enterRoom(collaborationRoomName, collaborationStorePath);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      entityId,
      data,
      attachmentOnlyIndicator,
      currentlyCollaborating,
      collaborationAttachments,
    } = this.props;
    const prevPropsData = !prevProps.data ? [] : _.sortBy(prevProps.data);
    const dataSorted = !data ? [] : _.sortBy(data);

    let [sortBy, sortOrder] = this.determineSortByAndOrder();
    const prevCollabAttachments = !prevProps.collaborationAttachments
      ? []
      : _.orderBy(prevProps.collaborationAttachments, sortBy, sortOrder);
    const currCollabAttachments = !collaborationAttachments
      ? []
      : _.orderBy(collaborationAttachments, sortBy, sortOrder);

    if (
      currentlyCollaborating &&
      !_.isEqual(prevCollabAttachments, currCollabAttachments)
    ) {
      // filter as non-CE api calls would
      // first create a copy of previous attachments, then apply the diffs between new and previous to that copy
      let attachments = _.cloneDeep(prevCollabAttachments);
      attachments = produceAppliedDiff(
        prevCollabAttachments,
        currCollabAttachments,
        attachments
      );
      // then apply the same filtering the backend attachment service would use when retrieveAttachmentsForEntity(...) is called
      attachments = this.filterAttachments(
        attachments,
        this.props.attachmentType,
        this.props.excludeAttachmentTypes
      );
      this.postAttachmentLoadProcessing(attachments, prevState.attachments);
      return;
    }

    if (
      (entityId && entityId !== prevProps.entityId) ||
      (!_.isEqual(dataSorted, prevPropsData) &&
        !_.isEqual(dataSorted.length, prevPropsData.length) &&
        !currentlyCollaborating)
    ) {
      this.retrieveAttachments();
    }

    //update attachmentId value in dynamoDB
    if (
      !_.isEqual(this.state.attachments, prevState.attachments) &&
      attachmentOnlyIndicator === 'Yes'
    ) {
      this.syncAttachmentDataToReduxForPassIdOnly(this.state.attachments);
    }
  }

  filterAttachments(attachments, attachmentType, excludeAttachmentTypes) {
    if (attachmentType) {
      return _.filter(
        attachments,
        (attachment) => attachment.attachmentType == attachmentType
      );
    } else if (excludeAttachmentTypes) {
      return _.filter(
        attachments,
        (attachment) => !excludeAttachmentTypes.includes(attachment.attachmentType)
      );
    }
    return attachments;
  }

  postAttachmentLoadProcessing(attachments, prevStateAttachments) {
    let {
      saveEntitySessionData,
      filterAttachmentName,
      data,
      showOnlyLinkedAttachments,
      sortBy,
      entityDataPath,
    } = this.props;
    saveEntitySessionData(entityDataPath, attachments);
    if (sortBy) {
      attachments = _.orderBy(attachments, sortBy, 'desc');
    }
    if (filterAttachmentName) {
      // client side filter, DO NOT USE unless the attachment type is for a system generated attachment
      attachments = _.filter(
        attachments,
        (att) => _.toUpper(att.fileName) == _.toUpper(filterAttachmentName)
      );
    }
    if (showOnlyLinkedAttachments) {
      attachments = _.intersectionWith(attachments, data, (file1, file2) =>
        _.isEqual(file1.resourceId, file2.resourceId)
      );
    }
    if (!_.isEqual(attachments, prevStateAttachments)) {
      this.setState({
        attachments,
        loading: false,
      });
    }
  }

  // double check this entity type is still the requirement...
  getEntityType = () => {
    let {task, process, taskWF, processWF} = this.props;
    return process ? `${process}|${task}` : `${processWF}|${taskWF}`;
  };

  uploadAttachment = (attachmentType, files) => {
    let {
      token,
      entityId,
      entityType,
      organizationId,
      subOrgId,
      programId,
      categoryId,
      visibility,
      task,
      process,
      taskWF,
      processWF,
    } = this.props;

    // TODO, the underlying components are setup to support bulk-upload, but we can only take the first one for now.
    if (!_.isEmpty(files)) {
      let file = files[0];
      let useTask = task || taskWF;
      let useProcess = process || processWF;
      let form = FileTransferUtils.createFormData(
        file,
        attachmentType,
        entityId,
        entityType,
        organizationId,
        subOrgId,
        programId,
        categoryId,
        visibility || DEFAULT_VISIBILITY,
        useTask,
        useProcess
      );
      const roomName = this.props.currentlyCollaborating
        ? this.props.collaborationRoomName
        : undefined;
      return this.props.uploadAttachment(token, form, roomName);
    } else {
      return Promise.reject();
    }
  };

  updateRedux(filesSuccesful, sessionOnly = false) {
    const {attachmentOnlyIndicator, sessionDataPath, saveEntitySessionData} = this.props;

    //In order for the description in redux, we have added the additional logic so that the function is called when sessionDataPath is set.
    //sessionOnly is true only for handleUpdateDescription which can be found in the Uploader.js
    if (sessionOnly) {
      saveEntitySessionData(sessionDataPath, filesSuccesful);
    } else {
      if (attachmentOnlyIndicator === 'Yes')
        this.syncAttachmentDataToReduxForPassIdOnly(filesSuccesful);
      else this.syncAttachmentDataToRedux(filesSuccesful);
    }
    return true;
  }

  syncAttachmentDataToRedux(attachments) {
    const {entityDataPath, metaDataEntityType, saveEntityData, dataPath} = this.props;
    if (entityDataPath) {
      saveEntityData(entityDataPath, metaDataEntityType, attachments, 'uploader');
    } else if (dataPath) {
      this.saveValueToDataPath(attachments, dataPath);
    }
  }

  syncAttachmentDataToReduxForPassIdOnly(attachments) {
    const {entityDataPath, metaDataEntityType, dataPath} = this.props;
    let attachmentIds = _.map(attachments, (attachment) => _.toString(attachment.id));

    this.setState({
      attachmentIds: attachmentIds,
    });
  }

  retrieveAttachments = _.debounce(() => {
    const filterOptions = {};
    let {
      filterAttachmentName,
      showAllAttachments,
      attachmentType,
      data,
      showOnlyLinkedAttachments,
      excludeAttachmentTypes,
      sortBy,
    } = this.props;
    if (!showAllAttachments) {
      filterOptions.attachmentType = attachmentType;
    } else {
      filterOptions.excludeAttachmentTypes = excludeAttachmentTypes;
    }
    const {
      token,
      entityId,
      entityType,
      entityDataPath,
      saveEntitySessionData,
    } = this.props;
    return this.props
      .retrieveAttachmentsForEntity(
        token,
        entityId,
        entityType || this.getEntityType(),
        filterOptions
      )
      .then((res) => {
        if (res.type === API_ATTACHMENT_GET_SUCCESS) {
          let attachments = res.payload;
          saveEntitySessionData(entityDataPath, attachments);
          if (sortBy) {
            attachments = _.orderBy(attachments, sortBy, 'desc');
          }
          if (filterAttachmentName) {
            // client side filter, DO NOT USE unless the attachment type is for a system generated attachment
            attachments = _.filter(
              attachments,
              (att) => _.toUpper(att.fileName) == _.toUpper(filterAttachmentName)
            );
          }
          if (showOnlyLinkedAttachments) {
            attachments = _.intersectionWith(attachments, data, (file1, file2) =>
              _.isEqual(file1.resourceId, file2.resourceId)
            );
          }
          this.setState({
            attachments,
            loading: false,
          });

          return true;
        }
        this.setState({loading: false});
        return Promise.reject();
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        console.error('failed to retrieve attachments');
        return false;
      });
  }, 500);

  deleteAttachment = (resourceId) => {
    let {
      token,
      deleteAttachment,
      extended_attachment,
      resetOnDelete,
      deleteAttachmentsOnHide,
    } = this.props;

    if (
      extended_attachment &&
      deleteAttachmentsOnHide &&
      deleteAttachmentsOnHide == true
    ) {
      if (resetOnDelete && resetOnDelete.status === true)
        this.saveValueToDataPath(false, resetOnDelete.dataPaths[0]);
    }

    const roomName = this.props.currentlyCollaborating
      ? this.props.collaborationRoomName
      : undefined;
    return deleteAttachment(token, resourceId, roomName);
  };

  determineSortByAndOrder = () => {
    /* 2025-04-29
     * this.props.sortBy appears only in the ehpReview.json config file (w/ value of 'uploadedDate'),
     * in retrieveAttachments, if it exists, it is used to sort attachments in descending order.
     * Updating this component for Collaborative Editing (CE) I wanted to introduce a consistent
     * ordering and avoid some reordering situations that were occurring.  If props.sortBy
     * is defined set its sortOrderProp to 'desc' as is used when its defined elsewhere.
     * If props.sortBy is not defined sort by uploadedDate asc.
     * Return sortBy and sortOrder in an array.
     */
    let sortByProp = 'uploadedDate';
    let sortOrderProp = 'asc';
    if (this.props.sortBy) {
      sortByProp = this.props.sortBy;
      sortOrderProp = 'desc';
    }
    return [sortByProp, sortOrderProp];
  };

  renderReview = () => {
    const {
      attachmentType,
      acceptedFileTypes,
      fileSizeLimit,
      displayFormat,
      numRequired,
      numAllowed,
      guidance,
      header,
      instructionalText,
      readOnly,
      displayHeader,
      is1GbAttachmentAccepted,
      attachmentOnlyIndicator,
      avoid1GbAttachmentSaveError,
      extended_attachment,
      showAttachmentType,
      showAcceptedFileTypes,
      showSubmittedFileSize,
      buttonMsg,
      headerSize,
      showUnsubmitted,
      showUnsubmittedOnly,
      id,
      showOnlyDeletableAttachments,
      hideDeleteforNumRequired = false,
      hideAction = false,
      sessionDataPath,
      currentlyCollaborating,
    } = this.props;
    const displayError = isDisplayError(this.props.dataErrors, this.props.pathToBeUsed);

    let [sortBy, sortOrder] = this.determineSortByAndOrder();
    const roomName = this.props.currentlyCollaborating
      ? this.props.collaborationRoomName
      : undefined;
    return (
      <React.Fragment>
        {displayHeader ? (
          <Header as="h1">Attachments</Header>
        ) : extended_attachment ? (
          <Header as={headerSize || 'h4'}>{header}</Header>
        ) : null}
        {instructionalText ? <p>{instructionalText}</p> : null}
        <Segment
          basic={displayFormat === 'panel'}
          vertical={displayFormat === 'nestedSegment'}
          className="no-divider"
        >
          <ReviewAttachments
            header={header}
            currentFiles={this.state.attachments}
            attachmentType={attachmentType}
            uploadAttachment={(attachmentType, files) =>
              this.uploadAttachment(attachmentType, files)
            }
            deleteAttachment={(resourceId) => this.deleteAttachment(resourceId)}
            updateDescription={(payload) =>
              this.props.updateDescription(this.props.token, payload, roomName)
            }
            currentlyCollaborating={currentlyCollaborating}
            showAttachmentType={showAttachmentType}
            buttonMsg={buttonMsg}
            acceptedFileTypes={acceptedFileTypes}
            fileSizeLimit={fileSizeLimit}
            numRequired={numRequired}
            numAllowed={numAllowed}
            displayFormat={displayFormat}
            guidance={guidance}
            resync={this.retrieveAttachments}
            readOnly={readOnly}
            attachmentOnlyIndicator={attachmentOnlyIndicator}
            is1GbAttachmentAccepted={is1GbAttachmentAccepted}
            avoid1GbAttachmentSaveError={avoid1GbAttachmentSaveError}
            extended_attachment={extended_attachment}
            showAcceptedFileTypes={showAcceptedFileTypes}
            showSubmittedFileSize={showSubmittedFileSize}
            updateRedux={this.updateRedux}
            showUnsubmitted={showUnsubmitted}
            showUnsubmittedOnly={showUnsubmittedOnly}
            saveDataErrors={this.props.saveDataErrors}
            hideUploadedBy={this.props.hideUploadedBy}
            hrefId={id}
            sortBy={sortBy}
            sortOrder={sortOrder}
            showOnlyDeletableAttachments={showOnlyDeletableAttachments}
            hideDeleteforNumRequired={hideDeleteforNumRequired}
            hideAction={hideAction}
            sessionDataPath={sessionDataPath}
          />

          {displayError && (
            <div className={'errorMessages'}>
              {errorMessages(this.props.dataErrors, this.props.pathToBeUsed)}
            </div>
          )}
        </Segment>
      </React.Fragment>
    );
  };

  renderUploader = () => {
    const {
      attachmentType,
      acceptedFileTypes,
      fileSizeLimit,
      displayFormat,
      numRequired,
      numAllowed,
      guidance,
      errorMessage,
      extended_attachment,
      buttonMsg,
      hideDeleteforNumRequired = false,
      hideAction = false,
      sessionDataPath,
      currentlyCollaborating,
    } = this.props;

    const attachments = _.filter(
      this.state.attachments,
      (attachment) => attachment.attachmentType === attachmentType
    );

    return (
      <React.Fragment>
        <Uploader
          attachmentType={attachmentType || ''}
          uploadAttachment={this.uploadAttachment}
          deleteAttachment={this.deleteAttachment}
          updateDescription={(payload) =>
            this.props.updateDescription(this.props.token, payload)
          }
          buttonMsg={buttonMsg}
          savedAttachments={attachments}
          acceptedFileTypes={acceptedFileTypes}
          fileSizeLimit={fileSizeLimit}
          numAllowed={numAllowed}
          numRequired={numRequired}
          displayFormat={displayFormat}
          guidance={guidance}
          resync={this.retrieveAttachments}
          validate={this.validate}
          saveDataErrors={this.props.saveDataErrors}
          errorMessage={errorMessage}
          updateRedux={this.updateRedux}
          extended_attachment={extended_attachment}
          showUnsubmittedOnly={this.props.showUnsubmittedOnly}
          hideDeleteforNumRequired={hideDeleteforNumRequired}
          hideAction={hideAction}
          sessionDataPath={sessionDataPath}
        />
      </React.Fragment>
    );
  };

  render() {
    const {uploaderOnly, isHidden, validationErrors, validationDirtyMap} = this.props;
    const errorMessage = getFirstInvalidErrorMessage(
      validationDirtyMap,
      validationErrors
    );
    const Component = uploaderOnly ? this.renderUploader : this.renderReview;
    if (isHidden) return <React.Fragment />;
    else if (errorMessage) {
      return (
        <Segment basic className={'errorBorderLine'}>
          {!this.state.loading ? <Component /> : <Loader />}
          <div className={'errorMessages'}>{errorMessage}</div>
        </Segment>
      );
    } else {
      return <Component />; //call component right away to solve focusing 508 issue
    }
  }
}

export class DynamicReviewAttachments extends React.Component {
  render() {
    return <_DynamicReviewAttachments {...this.props} {...{rulesMap}} />;
  }
}

export const mapStateToProps = (state, ownProps) => {
  let visibility = isFemaUser(_.get(state, 'auth.permissions')) ? 'internal' : 'external';
  let entityTypeOrProcTaskDefKey =
    ownProps.entityType ||
    `${_.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.processKey'
    )}|${_.get(state, 'dynamicComponent.context.workflowTask.task.taskDefinitionKey')}`;
  let collaborationStorePath = `collaboration.sync.attachments.${visibility}.${ownProps.entityId}/${entityTypeOrProcTaskDefKey}`;
  let collaborationRoomName = `attachments/${visibility}/${ownProps.entityId}/${entityTypeOrProcTaskDefKey}`;
  return {
    token: _.get(state, 'auth.token'),
    taskWF: _.get(state, 'dynamicComponent.context.workflowTask.task.taskDefinitionKey'),
    processWF: _.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.processKey'
    ),
    currentlyCollaborating: !!_.get(state, 'dynamicComponent.collaboration.roomList', ''),
    collaborationStorePath,
    collaborationAttachments: _.get(
      state,
      `dynamicComponent.${collaborationStorePath}`,
      []
    ),
    visibility,
    collaborationRoomName,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDescription: (token, payload, collaborationRoomName) => {
    const action = ApiActions.attachments.updateDescription(token, payload);
    const response = dispatch(action);
    if (collaborationRoomName) {
      response.then((result) => {
        dispatch(CollaborationActions.refetchRoom({roomName: collaborationRoomName}));
        return result;
      });
    }
    return response;
  },
  enterRoom: (collaborationRoomName, collaborationStorePath) => {
    // leave room will be taken care of by navigation.
    dispatch(
      CollaborationActions.enterRoom({
        roomName: collaborationRoomName,
        storePath: collaborationStorePath,
        isDependency: true,
        isOptional: true,
        cancelReset: true,
      })
    );
  },
});

export default compose(
  connectDynamic,
  withAttachmentApi,
  connect(mapStateToProps, mapDispatchToProps)
)(DynamicReviewAttachments);
